import React from "react";
import Image from "next/image";
import ProductTitle from "./ProductTitle";
import { monitorCards, monitorSubTitle, monitorTitle } from "./product";
import { monitorCardImage } from "../images";

type Props = object;

function Monitor({}: Props) {
  return (
    <section id="monitor" className="w-full py-16 md:py-24">
      <ProductTitle
        title={monitorTitle}
        subTitle={monitorSubTitle}
        pillLabel="Monitor"
      />

      {/* Cards */}
      <div className="mx-auto mt-10 grid max-w-6xl grid-cols-1 gap-4 px-4 sm:grid-cols-2 md:mt-14 md:grid-cols-2 md:gap-6 lg:grid-cols-3">
        {monitorCards.map(({ title, subTitle }, idx) => {
          const icons = [
            monitorCardImage.proactive,
            monitorCardImage.autofix,
            monitorCardImage.scaling,
            monitorCardImage.setup,
            monitorCardImage.cost,
          ];
          const icon = icons[idx];
          return (
            <article
              key={title}
              className="group relative mx-auto w-full max-w-[520px] overflow-hidden rounded-xl border border-white/10 bg-gradient-to-br from-zinc-900/50 to-zinc-800/30 p-4 backdrop-blur-sm transition-all duration-300 hover:border-white/20 hover:shadow-xl md:p-5"
            >
              {/* Subtle background gradient overlay */}
              <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-transparent via-white/5 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

              <div className="relative">
                {/* Icon */}
                <div className="mb-4">
                  <div className="relative inline-flex h-12 w-12 items-center justify-center">
                    <Image
                      src={icon}
                      alt={title}
                      width={40}
                      height={40}
                      className="h-8 w-8 object-contain opacity-90"
                    />
                  </div>
                </div>

                {/* Text */}
                <h3
                  className="font-dm mb-2 text-[16px] font-medium tracking-[-0.03em] md:text-[18px]"
                  style={{
                    background:
                      "linear-gradient(135deg, #FCFCFC 0%, #A0A0A0 50%, #505050 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                  }}
                >
                  {title}
                </h3>
                <p className="font-dm text-[13px] leading-[1.6] tracking-[-0.02em] text-zinc-300 md:text-[14px]">
                  {subTitle}
                </p>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default Monitor;
